const T_PREFIX = "inquiry-card";

export const inquiryCardTrns = {
  minInvLabel: `${T_PREFIX}.min-inv-label`,
  minInvFrom: `${T_PREFIX}.min-inv-from`,
};

export const actionButtonsTrns = {
  deleteButton: `${T_PREFIX}.action-buttons.delete-btn`,
  pauseButton: `${T_PREFIX}.action-buttons.pause-btn`,
  restoreButton: `${T_PREFIX}.action-buttons.restore-btn`,
  editButton: `${T_PREFIX}.action-buttons.edit-btn`,
};

export const actionButtonsModalTrns = {
  deleteModalDesc: `${T_PREFIX}.action-buttons.modal.delete`,
};
